export default __webpack_public_path__ + "static/media/gallery-wip-neck_01.32029629.jpg";